import Layout from "@/components/Layout/Layout";
import ResourcesLayout from "./ResourcesLayout";

export default function Bibliography({ section, data, close, white }) {

    const books = data?.[0]?.bibliography_data || null;

    return (
        <Layout section={section}>
            <ResourcesLayout data={data} close={close} white={white}>
                <ul className="area-card--links flow--l">
                    {books.map((book) => {
                        const {
                            section_id,
                            ref_publications_title, ref_publications_authors,
                            ref_publications_editor,
                            ref_publications_place,
                            ref_publications_date,
                        } = book;
                        return (
                            <li key={section_id} className="link-block-bibliography">
                                <h2 className="is-size-2 has-text-weight-semibold">{ref_publications_title}</h2>
                                {ref_publications_authors && (
                                    <p>{ref_publications_authors}</p>
                                )}
                                {ref_publications_editor && (
                                    <p>{ref_publications_editor}</p>
                                )}
                                {ref_publications_place && (
                                    <p>{ref_publications_place}</p>
                                )}
                                {ref_publications_date && (
                                    <p>{ref_publications_date}</p>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </ResourcesLayout>
        </Layout>
    )
}